export default __webpack_public_path__ + "static/media/download-icon.9a75b99c.svg";